/* eslint-disable */

export const SIStatusBadge = ({
	submitted,
	eligible,
	onEdit,
	label = "SI Underwriting",
	bottomOffset
}: {
	submitted: boolean;
	eligible: boolean | undefined;
	onEdit: () => void;
	label?: string;
	/** Overrides the default negative bottom offset when the parent clips overflow. */
	bottomOffset?: number;
}) => {
	if (!submitted) {
		return (
			<div
				style={{
					position: "absolute",
					bottom: bottomOffset ?? -20,
					right: 16,
					display: "flex",
					alignItems: "center",
					gap: 6,
					background: "rgba(234,88,12,0.08)",
					border: "1px solid rgba(234,88,12,0.3)",
					borderRadius: 8,
					padding: "5px 12px",
					zIndex: 2
				}}
			>
				<span style={{ fontSize: "0.72rem", color: "#c2410c", fontWeight: 600, letterSpacing: 0.2 }}>
					⚠ {label} Required
				</span>
			</div>
		);
	}

	return (
		<div
			style={{
				position: "absolute",
				bottom: bottomOffset ?? -14,
				right: 16,
				display: "flex",
				alignItems: "center",
				gap: 8,
				zIndex: 2
			}}
		>
			<div
				style={{
					display: "inline-flex",
					alignItems: "center",
					gap: 6,
					padding: "4px 12px",
					borderRadius: 8,
					fontSize: "0.72rem",
					fontWeight: 600,
					letterSpacing: 0.2,
					background: eligible ? "rgba(22,163,74,0.08)" : "rgba(234,88,12,0.08)",
					color: eligible ? "#15803d" : "#c2410c",
					border: `1px solid ${eligible ? "rgba(22,163,74,0.25)" : "rgba(234,88,12,0.3)"}`
				}}
			>
				{eligible ? (
					<>
						<svg width="12" height="12" viewBox="0 0 12 12" fill="none">
							<circle cx="6" cy="6" r="6" fill="#16a34a" fillOpacity="0.15" />
							<path
								d="M3.5 6l1.8 1.8 3.2-3.6"
								stroke="#16a34a"
								strokeWidth="1.4"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
						SI Approved — Pending Review
					</>
				) : (
					<>
						<svg width="12" height="12" viewBox="0 0 12 12" fill="none">
							<circle cx="6" cy="6" r="6" fill="#c2410c" fillOpacity="0.15" />
							<path d="M6 3.5v3M6 8h.01" stroke="#c2410c" strokeWidth="1.4" strokeLinecap="round" />
						</svg>
						Full Underwriting Required — Sent for Review
					</>
				)}
			</div>
			<button
				type="button"
				onClick={onEdit}
				style={{
					fontSize: "0.72rem",
					padding: "4px 11px",
					borderRadius: 8,
					border: "1px solid rgba(99,102,241,0.4)",
					background: "rgba(99,102,241,0.06)",
					color: "#4f46e5",
					cursor: "pointer",
					fontWeight: 600,
					letterSpacing: 0.2,
					display: "flex",
					alignItems: "center",
					gap: 4,
					transition: "all 0.15s"
				}}
				onMouseEnter={(e) => {
					(e.currentTarget as HTMLButtonElement).style.background = "rgba(99,102,241,0.12)";
					(e.currentTarget as HTMLButtonElement).style.borderColor = "#6366f1";
				}}
				onMouseLeave={(e) => {
					(e.currentTarget as HTMLButtonElement).style.background = "rgba(99,102,241,0.06)";
					(e.currentTarget as HTMLButtonElement).style.borderColor = "rgba(99,102,241,0.4)";
				}}
			>
				<svg width="11" height="11" viewBox="0 0 11 11" fill="none">
					<path
						d="M7.5 1.5a1.121 1.121 0 011.586 1.586L3.5 8.667 1 9.5l.833-2.5L7.5 1.5z"
						stroke="#4f46e5"
						strokeWidth="1.2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
				Revise
			</button>
		</div>
	);
};
